import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBatchesGeneral, getBatchesMain, getBatchesUser, getReasonsForDeletion } from '../../../../actions/marketPlaceActions'
import { getSubOrdesByCode } from '../../../actions/transferActions'
import CreateDevolution from '../../../containers/Inventory/Devolutions/CreateDevolution'

const CreateDevolition = () => {
    const dispatch = useDispatch()
    const { pendingOrder } = useSelector(state => state.tranfers)
    const { reasonsfordeletion } = useSelector(state => state.marketPlace)
    const [orderId, setOrderId] = useState(null)
    const search = () => {
        dispatch(getSubOrdesByCode(orderId))
    }
    useEffect(() => {
        dispatch(getReasonsForDeletion())

        return () => {

        }
    }, [])

    const getBatches = (subOrder) => {

        if (pendingOrder.length > 0) {
            let order = subOrder.orderId
            console.log();
            if (order.transmitterType ==="user") {
                dispatch(getBatchesUser(subOrder.orderId._id, subOrder.productId._id, order.transmitterUserId))
            }
            if (order.transmitterType ==="franchise") {
                dispatch(getBatchesGeneral(subOrder.orderId._id, subOrder.productId._id, order.transmitterFranchiseId))
            }
            if (pendingOrder.transmitterType ==="representative") {
                dispatch(getBatchesGeneral(subOrder.orderId._id, subOrder.productId._id))
            }
            if (order.transmitterType ==="warehause") {
                dispatch(getBatchesMain(subOrder.orderId._id, subOrder.productId._id))
            }
        }
    }
    return (
        <CreateDevolution
            reasonsfordeletion={reasonsfordeletion}
            getBatches={getBatches}
            search={search}
            setOrderId={setOrderId}
            orderId={orderId}
            subOrders={pendingOrder}
        />
    )
}

export default CreateDevolition